import { atom } from "recoil";

import { persistAtom } from "../persist";

import { Tariff } from "@types";

export const tariffsState = atom<Tariff | undefined>({
    key: "tariffsState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});
